// src/App.jsx
import { useRoutes } from "react-router-dom";
import { CssBaseline, Box, CircularProgress } from "@mui/material";
import RoutingHandler from "./router";
import { MsalProvider } from "@azure/msal-react";
import "./App.css";
import { initializeMsal, msalInstance } from "./config/authConfig";
import { useEffect, useState } from "react";
import { ThemeProvider } from "./context/ThemeContext";
import ToasterComp from "./components/Toaster/Toaster";

function App() {
  const [msalInitialized, setMsalInitialized] = useState(false);
  const router = RoutingHandler;
  const content = useRoutes(router);

  useEffect(() => {
    const initMsal = async () => {
      try {
        await initializeMsal();
        setMsalInitialized(true);
      } catch (error) {
        console.error("Failed to initialize MSAL:", error);
      }
    };

    initMsal();
  }, []);

  if (!msalInitialized) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <ThemeProvider>
        <CssBaseline />
        <ToasterComp />
        {content}
      </ThemeProvider>
    </MsalProvider>
  );
}

export default App;
